import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import FilterModal from "../Filter Modal/FilterModal";

export default function DataTable_Component({ apidata, columns, searchBy }) {
  const today = new Date().toISOString().split("T")[0];

  const [dataFilter, setDataFilter] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [hubFilter, setHubFilter] = useState("");
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [utilizationStats, setUtilizationStats] = useState({
    totalUtilization: "0",
    vehicleCrossUtilization: "0",
    activeVehicles: "",
  });
  const [originalData, setOriginalData] = useState([]);

  const fetchFilteredData = async (from = today, to = today) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }

      const params = new URLSearchParams();
      if (from) params.append("from_date", from);
      if (to) params.append("to_date", to);

      const response = await fetch(
        `${
          process.env.REACT_APP_BASE_URL
        }/api/v3/daily-cross-vehicle-utilization?${params.toString()}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const result = await response.json();
      const data = result?.data?.data;
      const vehicleData = data?.vehicleData || [];

      setFilteredData(vehicleData);
      setUtilizationStats({
        totalUtilization: data?.totalUtilization || "0",
        vehicleCrossUtilization: data?.vehicleCrossUtilization || "0",
        activeVehicles: data?.activeVehicles || "0",
      });
      setOriginalData(vehicleData); // Store raw data
      setFilteredData(vehicleData); // Show initially
    } catch (error) {
      console.error("Error fetching default data:", error);
    }
  };

  useEffect(() => {
    fetchFilteredData(); // Fetch data for current date on mount
  }, []);

  useEffect(() => {
    let filtered = originalData;
    if (hubFilter) {
      filtered = filtered.filter((item) => {
        if (Array.isArray(item.hub)) {
          return item.hub.some(
            (hubName) =>
              hubName && hubName.toLowerCase().includes(hubFilter.toLowerCase())
          );
        }
        return false;
      });
    }

    if (dataFilter) {
      filtered = filtered.filter((item) => {
        if (searchBy === "vehicleNumber") {
          return (
            item.vehicleNumber &&
            item.vehicleNumber.toLowerCase().includes(dataFilter.toLowerCase())
          );
        }
        return false;
      });
    }

    setFilteredData(filtered);
  }, [dataFilter, hubFilter, searchBy, originalData]);

  const applyFilters = async () => {
    await fetchFilteredData(fromDate, toDate);
    setShowFilterModal(false);
  };

  const removeFilters = () => {
    setHubFilter("");
    setFromDate(today);
    setToDate(today);
    fetchFilteredData(today, today);
    setShowFilterModal(false);
  };

  return (
    <div className="table-responsive">
      <div className="row justify-content-between mb-2">
        <div className="col-md-3 mb-2">
          <input
            type="text"
            placeholder={`Search by ${searchBy}`}
            className="form-control"
            value={dataFilter}
            onChange={(e) => setDataFilter(e.target.value)}
          />
        </div>
        <div className="col-md-9 mb-2 d-flex align-items-center">
          <button
            className="btn btn-primary me-2"
            onClick={() => setShowFilterModal(true)}
          >
            Filter
          </button>
          <button
            className="btn btn-success  me-2"
            onClick={() => {
              fetchFilteredData(fromDate, toDate);
            }}
          >
            TOTAL UTILIZATION :{" "}
            <span className="text-light ms-1">
              {utilizationStats.totalUtilization} %
            </span>
          </button>
          <button
            className="btn btn-success  me-2"
            onClick={() => {
              const filtered = filteredData.filter(
                (item) => item.tripsTotal > 1
              );
              setFilteredData(filtered);
            }}
          >
            CROSS UTILIZATION :{" "}
            <span className="text-light">
              {utilizationStats.vehicleCrossUtilization} %
            </span>
          </button>
          <small className="btn btn-success me-2">
            ACTIVE VEHICLES :{" "}
            <span className="text-light">
              {utilizationStats.activeVehicles}
            </span>
          </small>
        </div>
      </div>

      {filteredData.length > 0 ? (
        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          fixedHeader
          highlightOnHover
          responsive
          paginationPerPage={5}
          paginationRowsPerPageOptions={[5, 10, 15, 20]}
        />
      ) : (
        <div className="row justify-content-start">
          <div className="col-12">
            <p>No results found.</p>
          </div>
        </div>
      )}

      <FilterModal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        applyFilters={applyFilters}
        removeFilters={removeFilters}
        apidata={apidata}
        hubFilter={hubFilter}
        setHubFilter={setHubFilter}
        fromDate={fromDate}
        toDate={toDate}
        setFromDate={setFromDate}
        setToDate={setToDate}
      />
    </div>
  );
}
